import React, { useRef, useState } from "react";
import { Turnstile } from "@marsidev/react-turnstile";
import { MdOutlineEmail } from "react-icons/md";
import { BsTelegram } from "react-icons/bs";

import "./contact.css";

const Contact = () => {
    const [status, setStatus] = useState("idle");
    const [turnstileToken, setTurnstileToken] = useState("");
    const turnstileRef = useRef(null);

    const onSubmit = async (e) => {
        e.preventDefault();
        // const formData = new FormData(e.target);
        const form = e.currentTarget;

        if (!turnstileToken) {
            setStatus("error");
            setTurnstileToken("");
            turnstileRef.current?.reset();
            return;
        }

        setStatus("sending");

        const formData = new FormData(form);

        // Cloudflare Turnstile token
        formData.append("cf-turnstile-response", turnstileToken);

        try {
            const response = await fetch("https://api.kretsul.com/contact", {
                method: "POST",
                body: formData,
            });

            const data = await response.json();

            if (response.ok && data.success) {
                setStatus("success");

                // очищаємо форму тільки після успішної відправки
                form.reset();

                // очищаємо Turnstile token
                setTurnstileToken("");
                turnstileRef.current?.reset();

                window.setTimeout(() => {
                    setStatus("idle");
                }, 5000);
            } else {
                // ❗ форму НЕ очищаємо
                setStatus("error");

                // token одноразовий, тому його треба оновити
                setTurnstileToken("");
                turnstileRef.current?.reset();
            }
        } catch (error) {
            console.error(error);

            // ❗ форму НЕ очищаємо
            setStatus("error");

            // token одноразовий, тому його треба оновити
            setTurnstileToken("");
            turnstileRef.current?.reset();
        }
    };

    return (
        <section id="contact">
            <h5>Get In Touch</h5>
            <h2>Contact Me</h2>

            <div className="container contact__container">
                <div className="contact__options">
                    <article className="contact__option">
                        <MdOutlineEmail className="contact__option-icon" />
                        <h4>Email</h4>
                        <h5>vitalii@kretsul.com</h5>
                        <a href="mailto:vitalii@kretsul.com">Send a message</a>
                    </article>

                    <article className="contact__option">
                        <BsTelegram className="contact__option-icon" />
                        <h4>Telegram</h4>
                        <h5>@VitaliiKretsul</h5>

                        <a
                            href="https://t.me/VitaliiKretsul"
                            target="_blank"
                            rel="noreferrer">
                            Send a message
                        </a>
                    </article>
                </div>

                <form onSubmit={onSubmit}>
                    <input
                        type="text"
                        name="name"
                        placeholder="Your Full Name"
                        required
                    />

                    <input
                        type="email"
                        name="email"
                        placeholder="Your Email"
                        required
                    />

                    <textarea
                        name="message"
                        placeholder="Your message"
                        rows="6"
                        required
                    />

                    <Turnstile
                        ref={turnstileRef}
                        siteKey="0x4AAAAAAD9s1CkujQv1zvzv"
                        onSuccess={(token) => {
                            setTurnstileToken(token);
                        }}
                        onExpire={() => {
                            setTurnstileToken("");
                            turnstileRef.current?.reset();
                        }}
                        onError={() => {
                            setTurnstileToken("");
                            setStatus("error");
                            turnstileRef.current?.reset();
                        }}
                    />

                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={status === "sending" || !turnstileToken}>
                        {status === "sending" ? "Sending..." : "Send Message"}
                    </button>

                    {status === "success" && (
                        <span className="form__success">
                            ✓ Message sent! I'll reply as soon as possible.
                        </span>
                    )}

                    {status === "error" && (
                        <span className="form__error">
                            Something went wrong. Please try again or write me
                            on Telegram.
                        </span>
                    )}
                </form>
            </div>
        </section>
    );
};

export default Contact;
